<template>
  <div class="private_wrap" >
    <p style="text-align: center; font-weight: bold" >糖pai服务协议</p>

    {{ content }}

  </div>
</template>
<style scoped lang="less" >
@import "index";
</style>
<script>
export default {
  name: 'private',
  data() {
    return {
      content: " 本协议是用户与糖pai之间就您通过糖pai软件（包括糖paiAPP、糖pai小程序等，以下称“平台”）使用糖pai产品及服务等相关事宜所订立的契约。\n" +
        "\n" +
        "    您在申请注册流程中点击同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体下划线标识，您应重点阅读。如您对协议有任何疑问，可向客服咨询。\n" +
        "\n" +
        "    当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与糖pai达成一致，成为糖pai“用户”。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序。请您注意，我们会不时地检查并更新服务协议，因此有关服务协议的内容会随之变化。我们会按照相关法律法规要求对服务协议的变更予以公示，请您定期查看协议页面及公示页面，以确保您了解用户协议的最新版本。\n" +
        "\n" +
        "    第1条糖pai的用户\n" +
        "    1.1糖pai的用户：用户为具备中华人民共和国法律规定的与您的行为相适应的民事行为能力的人。用户应为以终端消费为目的的消费者，包括个人、国家机关、企业、事业单位及其他社会团体消费者，不包括以营利、销售等为目的的经销商。如发现用户为经销商的，糖pai有权拒绝为其提供服务，并有权注销其注册的账户，由此产生的一切后果由其自行承担。\n" +
        "    1.2糖pai的各项电子服务的所有权和运作权归糖pai所有。用户同意所有注册协议条款并完成注册程序，才能成为糖pai的正式用户。用户确认：本协议条款是处理双方权利义务的契约，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定。\n" +
        "    1.3用户选择糖pai支持的任一登录方式（包括手机验证码登录、本机号码一键登录、微信登录）等登陆并点击同意本协议的，即视为用户具备中华人民共和国法律规定的与您行为相适应的民事行为能力，能够独立承担法律责任。若您不具备前述与您行为相适应的民事行为能力，糖pai有权随时、全权决定拒绝向您提供服务，您及您的监护人应依照法律规定承担因此而导致的一切后果。\n" +
        "    1.4糖pai保留在中华人民共和国大陆地区法施行之法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容或取消订单的权利。\n" +
        "    1.5由于互联网高速发展，您与糖pai签署的本协议列明的条款并不能完整罗列并覆盖您与糖pai所有权利与义务，现有的约定也不能保证完全符合未来发展的需求。因此，糖pai隐私权政策等均为本协议的补充协议，与本协议不可分割且具有同等法律效力。如您使用糖pai服务，视为您同意上述补充协议。\n" +
        "    1.6同一用户多次重复注册糖pai账户会导致糖pai系统对该用户身份的真实性、获取账户的合理动机等产生质疑。除非该用户对其试图重复获取账号的行为作出合理解释，否则为保护广大真实用户的真实消费需求与合法权益，糖pai会拒绝或者直接注销您所有重复注册的账户，同时终止对这些重复注册账户提供服务。\n" +
        "\n" +
        "    第2条糖pai的服务\n" +
        "    2.1糖pai通过互联网依法为用户提供互联网信息等服务，用户在完全同意本协议及糖pai规定的情况下，方有权使用糖pai的相关服务。\n" +
        "    2.2在您下订单时，请您仔细确认所购商品的名称、价格、数量、规格、包装、保质期等信息以及联系地址、电话、收货人等信息。收货人与您本人不一致时，收货人的行为和意思表示视为您的行为和意思表示，您应对收货人的行为和意思表示的法律后果承担连带责任。\n" +
        "    2.3针对糖pai平台上的水果生鲜类产品，您理解出于水果生鲜食品仓储、运输的特殊性考虑，部分商品可能对销售区域作出限制，请您在下单时务必仔细查看商品详情页并准确填写收货地址，当收货地址超出配送范围时，糖pai有权拒绝接受您的订单。\n" +
        "    2.4您理解并同意：“当您作为消费者于糖pai下单并支付货款的情况下，您货款支付成功后即视为您与糖pai之间就已支付货款部分的订单建立了合同关系。”\n" +
        "    2.5对于由糖pai销售的商品，直到您发出订单并经我们确认发货，我们才能确认该商品的售价。尽管我们尽最大努力确保平台商品价格的准确性，平台商品目录中的一小部分商品可能偶尔会有定价错误。如果某一商品的正确定价应高于我们的平台定价，我们有权根据具体情况决定，在发货前联系您咨询您的意见，或者取消您的订单并通知您。\n" +
        "    2.6糖pai有权在发现平台上显示的商品及订单明显错误或缺货的情况下单方面撤回这些信息及订单。糖pai保留对商品订购数量的限制权，商品价格和可获性都将在平台上标明。送货费将另外结算费用根据用户选择的送货方式的不同而异。其他相关服务：\n" +
        "    2.7糖pai提供的服务内容可能包括：文字、软件、声音、图片、录像、图表等。所有这些内容受著作权、商标和其它财产所有权法律的保护。\n" +
        "    2.8用户只有在获得糖pai或其他相关权利人的授权之后才能使用这些内容，不能擅自复制、再造这些内容、或创造与内容有关的派生产品。\n" +
        "    2.9您不应通过糖pai张贴他人受知识产权法律等保护的内容，除非依据获得他人合法授权。就用户发布的内容，若第三方向糖pai投诉并提交初步证据的，经糖pai判断投诉属实的，糖pai将会删除这些内容，如因用户发布内容给糖pai带来损失的，用户应当负责赔偿。\n" +
        "    2.10用户知悉理解并同意其通过糖pai发布上传的内容，授权本公司及其关联公司、控制公司可在全球范围内、免费、非独家、可转授权地使用，使用范围包括但不限于在当前或其他网站、应用程序、产品或终端设备等，并授权公司及其关联公司、控制公司对相应内容可进行修改、复制、改编、翻译、汇编或制作衍生产品。\n" +
        "    第3条用户信息\n" +
        "    3.1用户应自行诚信向糖pai提供注册资料，用户同意其提供的注册资料真实、准确、完整、合法有效，用户注册资料如有变动的，应及时更新其注册资料。如果用户提供的注册资料不合法、不真实、不准确、不详尽的，用户需承担因此引起的相应责任及后果，并且糖pai保留终止用户使用糖pai各项服务的权利，您了解并同意，您有义务保持您提供信息的真实性及有效性。\n" +
        "    3.2用户在糖pai进行浏览、下单购物等活动时，涉及用户真实姓名/名称、通信地址、联系电话等隐私信息的，糖pai将予以严格保密，除非：\n" +
        "    (1)事先获得您的明确授权；\n" +
        "    (2)系为履行您的订单或保护您的合法权利所必须；\n" +
        "    (3)相应的法律程序及相关政府部门要求糖pai提供的。\n" +
        "    3.3用户注册成功后，将产生用户名和密码等账户信息，您可以根据糖pai规定改变您的密码。用户应谨慎合理的保存、使用其用户名和密码。用户若发现任何非法使用用户账号或存在安全漏洞的情况，请立即通知糖pai并向公安机关报案。\n" +
        "    糖pai账户与您的非现金支付工具是密切挂钩的，交由他人使用可能会造成您本人的支付工具端产生债权债务纠纷、资信问题等不良影响，因此糖pai请您不要将自己的账户给予他人使用。从公平合理的角度出发，您应知晓所有通过账户实现的操作，糖pai只能默认是您本人的行为，由此产生的后果由您自行独立承担。\n" +
        "    3.4用户同意，糖pai拥有通过短信、电话等形式，向在糖pai注册、购物用户、收货人发送订单信息、糖pai活动等告知信息的权利，您如果不愿意接收此类信息，您有权通过退订功能进行退订。\n" +
        "    3.5除非有法律规定或依生效司法裁决，或者根据糖pai公布的条件以及流程，用户不得以任何方式将在糖pai注册获得的账户转让或借给他人使用，否则糖pai有权追究您的违约责任，由此产生的一切责任均因当由您以及实际使用人承担连带责任。\n" +
        "    3.6用户同意，糖pai有权使用用户的注册信息、用密码等信息，登录进入用户的注册账户，进行证据保全，包括但不限于公证、见证等。\n" +
        "    3.7您设置的会员名、昵称不得违反国家法律法规规定，否则糖pai可回收您的会员名、昵称，若由此对糖pai造成损害的，应承担相应赔偿责任。\n" +
        "    3.8除糖pai存在过错外，您应对您账户项下的所有行为结果(包括但不限于在线签署各类协议、发布信息、购买商品及服务及披露信息等)负责。\n" +
        "    第4条用户行为\n" +
        "    本协议依据国家相关法律法规规章制定，用户同意严格遵守以下义务：\n" +
        "    (1)不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；\n" +
        "    (2)从中国大陆向境外传输资料信息时必须符合中国有关法规；\n" +
        "    (3)不得利用糖pai从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；\n" +
        "    (4)不得干扰糖pai的正常运转，不得侵入糖pai及国家计算机信息系统；\n" +
        "    (5)不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽的、不文明的等信息资料；\n" +
        "    (6)不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；\n" +
        "    (7)不得教唆他人从事本协议所禁止的行为；\n" +
        "    (8)不得利用在糖pai注册的账户进行牟利性经营活动；\n" +
        "    (9)不得发布任何侵犯他人著作权、商标权等知识产权或合法权利的内容；\n" +
        "    用户应不时关注并遵守糖pai不时公布或修改的各类合法规则规定。糖pai保有删除站内各类不符合法律政策或不真实的信息内容而无须通知用户的权利。\n" +
        "    若用户未遵守以上规定的，糖pai有权作出独立判断并采取暂停或关闭用户帐号等措施。用户将以自己的名义对自己在网上的言论和行为独立承担所有法律责任。\n" +
        "    第5条会员活动\n" +
        "    5.1您可以通过在糖pai网站参与商品评价、邀请其他用户等方式成为糖pai的会员活动。会员活动具有特定的规则和有效期，请您不时关注相关信息，活动规则以实际活动页上发布的为准。糖pai可根据活动举办的实际情况，在法律允许的范围内，对具体的活动规则进行变动或调整，相关变动或调整将公布在活动规则页面上。\n" +
        "    第6条配送\n" +
        "    6.1销售方将会把商品（货物）送到您所指定的收货地址，所有在糖pai上列出的送货时间为参考时间，参考时间的计算是根据库存状况、正常的处理过程和送货时间、送货地点的基础上估计得出的。参考时间不等同于到货时间，糖pai不会就送达时间向您作出精准承诺，您理解由于受库存、同时段订单量及其他外部因素的影响，送货时间可能会早于或晚于参考时\n" +
        "    间。\n" +
        "    6.2因如下情况造成订单延迟或无法配送等，糖pai不承担延迟配送以及订单商品无法送达的责任：\n" +
        "    (1)用户提供的信息错误、地址不详细等原因导致的；\n" +
        "    (2)货物送达后无人签收或交由他人代收前无法获得用户同意，导致无法配送或延迟配送的；(3)情势变更因素导致的；\n" +
        "    (4)不可抗力因素导致的，例如：自然灾害、交通戒严、突发战争等。\n" +
        "    (5)未能在糖pai所示的送货参考时间内送货的；\n" +
        "    (6)因节假日、大型活动、店庆、预购或抢购人数众多等原因导致的；\n" +
        "    6.3配送费用以您提交订单时页面显示的运费为准。您理解，如您需要变更时间或地址进行重新配送的，可能需要承担额外产生的配送服务费用。\n" +
        "    6.4为了保证配送及时准确、商品品质令人满意，您应当清楚准确地填写您的收货地址、联系人及联系方式等配送信息，您同意并授权糖pai将您的配送信息粘贴在商品外包装上，您理解这是为向您提供物流配送服务而必须的动作，糖pai提醒您收到商品后立即销毁外包装上的个人信息。您知悉并确认，您所购买的商品应仅由您填写的联系人接受身份查验后接收商品，因您变更联系人或相关配送信息而造成的损失由您自行承担。\n" +
        "    第7条知识产权\n" +
        "    7.1用户同意接受本协议，即表明该用户主动将其在任何时间段在糖pai发表的任何形式的信息内容（包括但不限于客户评价、客户咨询、各类话题文章等信息内容）的财产性权利等任何可转让的权利，如著作权财产权（包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利），全部不可撤销地授予糖pai使用。\n" +
        "    7.2除法律另有强制性规定外，未经糖pai明确的特别书面许可，任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用糖pai的信息内容，否则，糖pai有权追究其法律责任。\n" +
        "    7.3糖pai所刊登的资料信息（诸如文字、图表、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件），均是糖pai或其内容提供者的财产，受中国和国际版权法的保护。糖pai上所有内容的汇编是糖pai的财产，受中国和国际版权法的保护。糖pai上所有软件都是糖pai或其关联公司或其软件供应商的财产，受中国和国际版权法的保护。\n" +
        "    第8条免责条款\n" +
        "    8.1除非另有明确的书面说明，糖pai不对糖pai的运营及其包含在本网站上的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的声明或扣保。\n" +
        "    8.2您理解糖pai将严格按照法律规定以及本协议的约定，为您提供可靠、安全的产品及服务，但发生下列情形之一导致您遭受损失的，糖pai将不承担责任；\n" +
        "    (1)由于您未妥善管理您的账号信息，或未妥善保管您的登录设备的；\n" +
        "    (2)发生设备维护、信息网络连接故障、智能终端、通讯或其他系统故障等情形的;\n" +
        "    (3)发生地震、海啸、台风、洪水、战争、武斗冲突、罢工、骚乱、暴动、行政机构或司法机构发布命令等不可抗力事件的；\n" +
        "    (4)其他非因糖pai原因造成的。\n" +
        "    第9条法律管辖和适用\n" +
        "    9.1本协议的订立、执行和解释及争议的解决均应适用在中华人民共和国大陆地区适用之有效法律（但不包括其冲突法规则）。如发生本协议与适用之法律相抵触时，则这些条款将完全按法律规定重新解释，而其它有效条款继续有效。如缔约方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决;协商不成时，任何一方均可向糖pai住所地有管辖权的法院提起诉讼。\n" +
        "    第10条违约条款\n" +
        "    10.1出现以下情况之一时，视为您违约:\n" +
        "    (1)利用糖pai过错恶意索赔、投诉，无故对客服人员进行辱骂、人身攻击的；\n" +
        "    (2)违反本协议、本协议补充协议以及糖pai平台各项规则的；\n" +
        "    (3)违反有关法律法规规定的；\n" +
        "    (4)您多次（2次及以上）利用糖pai小程序的漏洞，恶意下单，谋取利益的；\n" +
        "    (5)您通过外挂工具、网络攻击或其他不正当行为非法获取悠币、优惠券等虚拟财产的(对此糖pai有权在不进行提前告知的情况下对违规账户进行冻结清算处理，并保留追究相关人员法律责任的权利；\n" +
        "    (6)您盗用他人账户、发布违禁信息、骗取他人财物、扰乱市场秩序、采取不正当手段谋利等行为的\n" +
        "    (7)您多次违反糖pai规则相关规定且依据糖pai判断情节严重的；\n" +
        "    (8)您有其他影响小程序正常经营秩序或违法行为的。\n" +
        "    10.2糖pai有权根据您的违约行为实施如下违约处理措施：\n" +
        "    (1)限制或取消会员账户的部分或者全部权限或功能\n" +
        "    (2)取消与违约行为相关的订单；\n" +
        "    (3)立即对相应信息进行删除、屏蔽处理；\n" +
        "    (4)情节严重的查封您的账户，终止向您提供服务。\n" +
        "    10.3如您的行为使糖pai及/或其关联公司遭受损失（包括自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损\n" +
        "    失），您应赔偿糖pai及/或其关联公司的上述全部损失。\n" +
        "    第11条协议的变更\n" +
        "    糖pai可根据国家法律法规变化及维护交易秩序、保护消费者权益需要，不定时修改本协议、补充协议，变更后的协议、补充协议（下称“变更事项”）将通过糖pai平台通知您。糖pai将会按照相关法律法规要求对本协议的变更予以公示，请您定期查看协议页面及公示页面。\n" +
        "    用户可随时登录查阅最新协议，并有权提出相关反馈建议；用户有义务不时关注并阅读最新版的协议及平台公告。\n" +
        "    如您对已生效的变更事项仍不同意的，您应当于变更事项确定的生效之日起停止使用糖pai平台服务，变更事项对您不产生效力；如您在变更事项生效后仍继续使用糖pai平台服务，则视为您同意已生效的变更事项。\n" +
        "    第12条通知\n" +
        "    12.1 有效联系方式\n" +
        "    您在注册成为糖pai用户，并接受糖pai服务时，您应该向糖pai提供真实有效的联系方式(包括您的联系电话、联系地址等)，对于联系方式发生变更的，您有义务及时更新有关信息，并保持可被联系的状态。您在使用糖pai平台用户时生成的收货信息，也作为您的有效联系方式。糖pai将向您的上述联系方式的其中之一或其中若干向您送达各类通知，而此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。\n" +
        "    12.2 通知的送达\n" +
        "    糖pai通过上述联系方式向您发出通知，其中以电子的方式发出的书面通知，包括但不限于在糖pai平台公告，向您提供的联系电话发送手机短信，向您的账号发送系统消息以及站内信信息，在发送成功后即视为送达。\n" +
        "    对于与糖pai平台有关的任何纠纷，您同意行政、公安、司法等有权机关可以通过手机短信、电子邮件、系统消息或站内信等方式向您送达法律文书，有权机关向上述联系方式发出法律文书即视为送达;若同时采取以上多种方式向您送达法律文书，送达时间以最先送达的为准。您同意上述送达方式适用于行政、仲裁、司法等法定程序全过程。\n" +
        "    第13条服务终止的情形\n" +
        "    13.1您有权通过以下任一方式终止本协议并不再接受糖pai的服务：\n" +
        "    (一)您通过小程序注销您的账户的；\n" +
        "    (二)变更事项生效前您停止使用并明示不愿接受变更事项的；\n" +
        "    (三)其它应当终止协议的情况。\n" +
        "    13.2出现以下情况时，糖pai可通过本协议所列的方式通知您终止本协议并终止服务：\n" +
        "    (一)您违反本协议约定，糖pai依据违约条款终止本协议的；\n" +
        "    (二)您盗用他人账户、发布违禁信息、骗取他人财物、扰乱平台交易秩序、采取不正当手段谋利等行为，糖pai对您的账户予以查封的；\n" +
        "    (三)除上述情形外，因您多次违反糖pai服务协议及平台规则等协议内容相关规定且情节严重，糖pai对您的账户予以查封的；\n" +
        "    (四)您的账户被糖pai依据本协议回收的；\n" +
        "    (五)其它应当终止服务的情况。\n" +
        "    第14条其他\n" +
        "    14.1如果根据适用的法律认定本协议中的任何条款或者任何条款中的任何部分无效、违法或者不具有可执行性，这种无效、违法或者不具有可执行性不影响本协议中的任何其它条款或者这些条款中的任何其它部分的效力。\n" +
        "    14.2糖pai尊重用户和消费者的合法权利，本协议及糖pai上发布的各类规则、声明等其他内容，均是为了更好的、更加便利的为用户和消费者提供服务。\n" +
        "    糖pai欢迎用户和社会各界提出意见和建议，糖pai将酌情考虑接受并适时修改本协议及糖pai上的各类规则。"
    }
  },
  methods: {

  }
}
</script>
